export const NCAAF_HEADER_COPY = {
  eyebrow: "Sports Hub • NCAAF",
  title: "NCAAF Terminal",
  description: "Track live games, standings, and teams from the college football landscape"
};
